import { motion } from 'framer-motion'
import { FaGithub, FaLinkedin, FaYoutube, FaFacebook, FaInstagram, FaHeart } from 'react-icons/fa'

const socials = [
  { icon: FaGithub,    href: 'https://github.com/ShankarTheCoder',            label: 'GitHub',    hoverColor: 'var(--text-1)', hoverBg: 'rgba(255,255,255,0.1)' },
  { icon: FaLinkedin,  href: 'https://linkedin.com/in/shankarthecoder',         label: 'LinkedIn',  hoverColor: '#0A66C2', hoverBg: 'rgba(10,102,194,0.1)' },
  { icon: FaYoutube,   href: 'https://www.youtube.com/@ShankarYt-20',          label: 'YouTube',   hoverColor: '#FF0000', hoverBg: 'rgba(255,0,0,0.1)' },
  { icon: FaFacebook,  href: 'https://www.facebook.com/shivshankarpandit93',   label: 'Facebook',  hoverColor: '#1877F2', hoverBg: 'rgba(24,119,242,0.1)' },
  { icon: FaInstagram, href: 'https://www.instagram.com/shivshankarpandit93/', label: 'Instagram', hoverColor: '#E1306C', hoverBg: 'rgba(225,48,108,0.1)' },
]

export default function Footer() {
  return (
    <footer className="relative py-10" style={{ borderTop: '1px solid var(--border)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-xl flex items-center justify-center font-display font-black text-white text-sm"
              style={{ background: 'linear-gradient(135deg,var(--accent-1),var(--accent-2))' }}>S</div>
            <span className="font-display text-sm font-semibold text-secondary">Shiv Shankar Pandit</span>
          </div>
          <p className="font-mono text-xs text-muted flex items-center gap-1.5">
            © 2026 ShivShankarPandit
          </p>
          <div className="flex items-center gap-1.5">
            {socials.map(({ icon: Icon, href, label, hoverColor, hoverBg }) => (
              <motion.a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                className="w-8 h-8 flex items-center justify-center rounded-xl transition-all"
                style={{ color: 'var(--text-3)' }}
                whileHover={{ scale: 1.18, color: hoverColor, background: hoverBg }}
                whileTap={{ scale: 0.9 }}>
                <Icon size={12} />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
